import {
  ActivateProgrammeRequest,
  CreateProgrammeRequest,
  DownloadTeamLeaderboardExcelRequest,
  SendMemberActivationCommunicationsRequest,
  UpdateProgrammeRequest,
  UploadMemberExcelRequest,
  ViewProgrammeRequest
} from './programme.types';

import {
  API_HOST,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/programme`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateProgrammeRequest = (
  data: CreateProgrammeRequest
): [string, HttpPostOptions<CreateProgrammeRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewAllProgrammesRequest = (): [string, HttpGetOptions] => [getEndpoint(), getHttpGetOptions()];

export const getViewProgrammeRequest = (data: ViewProgrammeRequest): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.externalReference),
  getHttpGetOptions()
];

export const getUpdateProgrammeRequest = (
  data: UpdateProgrammeRequest
): [string, HttpPutOptions<UpdateProgrammeRequest>] => [getEndpoint(), getHttpPutOptions(data)];

export const getActivateProgrammeRequest = (data: ActivateProgrammeRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/activate/${data.externalReference}`,
  getHttpGetOptions()
];

export const getDownloadTeamLeaderboardExcelRequest = (
  data: DownloadTeamLeaderboardExcelRequest
): [string, HttpPostOptions<DownloadTeamLeaderboardExcelRequest>] => [
  `${getEndpoint()}/excel/download`,
  getHttpPostOptions(data)
];

export const getSendMemberActivationCommunicationsRequest = (
  data: SendMemberActivationCommunicationsRequest
): [string, HttpPostOptions<void>] => [
  `${getSpecificEndpoint(data.programmeExternalReference)}/members/${
    data.memberExternalReference
  }/send-activation-communications`,
  getHttpPostOptions(undefined, undefined, { sendSms: String(data.sendSms), sendEmail: String(data.sendEmail) })
];

export const getUploadMemberExcelRequest = (
  data: UploadMemberExcelRequest
): [string, HttpPostOptions<Omit<UploadMemberExcelRequest, 'programmeExternalReference'>>] => [
  `${getSpecificEndpoint(data.programmeExternalReference)}/members/upload`,
  getHttpPostOptions({ data: data.data })
];
